import { h, Component, Prop } from '@stencil/core';
import { parseRootProps } from '../../utils/parse-helper';
import { Root, Severity } from '../../types/entities';

@Component({
  tag: 'ps-alert',
  styleUrl: 'alert.styles.scss',
})
export class Alert {
  @Prop() color: 'primary' | 'secondary' = 'primary';
  @Prop() severity: Severity = 'danger';
  @Prop() label?: string;
  @Prop({ reflect: true, mutable: true }) hide: boolean = false;
  @Prop() closeable: boolean = true;
  @Prop() root?: Root;

  getClassNames = (rootClass: string) => {
    const classes = ['ds-alert', `ds-alert--${this.severity}`];
    if (this.hide) {
      classes.push('ds-alert--hidden');
    }
    if (rootClass) {
      classes.push(rootClass);
    }
    return classes.join(' ');
  };

  getIconSymbol = (severity: Severity) => {
    switch (severity) {
      case 'info':
        return 'info';
      case 'success':
        return 'task_alt';
      case 'warning':
        return 'warning_amber';
      case 'danger':
        return 'error_outline';
    }
  };

  close = () => {
    this.hide = true;
  };

  render() {
    const { rootClass, attr } = parseRootProps(this.root);
    const classNames = this.getClassNames(rootClass);

    return (
      <div class={classNames}>
        <ps-box {...attr} color={this.color} severity={this.severity} border>
          <div class="ds-alert__wrapper">
            <div class="ds-alert__left">
              <ps-material-icon symbol={this.getIconSymbol(this.severity)} size="standard"></ps-material-icon>
            </div>
            <div class="ds-alert__center">
              {this.label && (
                <div class="ds-alert__title">
                  <ps-text type="bold">{this.label}</ps-text>
                </div>
              )}
              <div class="ds-alert__content">
                <slot></slot>
              </div>
            </div>
            {this.closeable && (
              <div class="ds-alert__right">
                <button class="ds-alert__close-btn" title="A button which closes the alert panel" onClick={() => this.close()}>
                  <ps-material-icon symbol="close"></ps-material-icon>
                </button>
              </div>
            )}
          </div>
        </ps-box>
      </div>
    );
  }
}
